import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-delete-card',
  templateUrl: './delete-card.component.html',
  styleUrls: ['./delete-card.component.scss']
})
export class DeleteCardComponent {

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<DeleteCardComponent>,
    @Inject(MAT_DIALOG_DATA) public card: any,
  ) { }
  ngOnInit(): void {    
  }

  closeModal() {
    this.dialogRef.close();
  }

  deleteCard(){
    this.userService.deleteSavedCardUser(this.card.id).subscribe((data: any) => {
      this.dialogRef.close(true);
    }
    );
  }
}
